import { applyCost, canAffordCost } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';
import { queueConstruction } from '../economy/construction';
import { canQueueBuilding } from '../economy/settlementLimits';

export const buildFishingHutAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    if (!canQueueBuilding(settlement, 'fishingHut')) return false;
    if (settlement.regionResources.fishCap <= 0) return false;
    const cost = state.config.buildings.fishingHut.cost || {};
    if (!canAffordCost(settlement, cost)) return false;
    applyCost(settlement, cost);
    queueConstruction(settlement, 'fishingHut', state.simulation.tick, cost);
    return true;
};
